import { useEffect, useState } from 'react';
import { IShare } from '../models/UserInfo';
import { userInfoApi } from '../services/apiServices/user/userInfo';
import { LocalStorageItems } from '../models/Common';

export const useFindShare = (shareId: number | string | undefined) => {
  const [share, setShare] = useState<IShare | null>(null);
  const controlledAccount = localStorage.getItem(LocalStorageItems.ControlledAccount);
  const { useGetUserInfoQuery, useGetUserInfoMultiAccQuery } = userInfoApi;
  const {
    data: userInfoState,
    isLoading: userInfoIsLoading,
    isSuccess,
  } = controlledAccount
    ? useGetUserInfoMultiAccQuery({ subAccountId: JSON.parse(controlledAccount).UserID })
    : useGetUserInfoQuery('');

  useEffect(() => {
    if (shareId && isSuccess) {
      const foundShare = userInfoState.Shares?.Activated.find((item) => item.id === +shareId) || null;
      setShare(foundShare);
    }
  }, [userInfoState]);

  return { share, isUserInfoDownloaded: !userInfoIsLoading };
};
